import { render } from "./Document.vue?vue&type=template&id=561b19b9&scoped=true&bindings={\"text\":\"data\",\"sideMenu\":\"data\",\"currentContext\":\"data\",\"currentVersion\":\"data\",\"currentDocument\":\"data\",\"scrollDebounce\":\"data\",\"documentMenus\":\"data\",\"documentCached\":\"data\",\"latestScroll\":\"data\",\"loadSideMenu\":\"options\",\"loadDocument\":\"options\",\"createDocumentMenu\":\"options\",\"activeDocumentMenu\":\"options\"}"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"

import "./Document.vue?vue&type=style&index=0&id=561b19b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-561b19b9"

export default script